<template>
    <div>
        <page-header :title="$t('pages.admin.series.title')" icon-class="mdi mdi-television">
            <div class="text-right">
                <router-link tag="a" :to="{name: 'admin.series.create'}" class="text-primary font-weight-bold">
                    <i class="mdi mdi-plus"></i> {{ $t('actions.create') }}
                </router-link>
            </div>
        </page-header>

        <div class="card shadow-sm">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                        <thead>
                            <tr>
                                <th>{{ $t('pages.admin.series.model.title') }}</th>
                                <th>{{ $t('pages.admin.series.model.show_in_sidebar') }}</th>
                                <th>{{ $t('pages.admin.series.model.show_in_coach') }}</th>
                                <th>{{ $t('pages.admin.series.model.amount_of_video') }}</th>
                                <th>{{ $t('actions.actions') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="series in seriesList">
                                <td>
                                    <img :src="series.thumbnail_url" :alt="series.title[$i18n.locale]" class="img-thumbnail mr-2">
                                    {{ series.title[$i18n.locale] }}
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="series.show_in_sidebar">
                                        <i class="mdi mdi-check"></i>
                                    </span>
                                    <span class="badge badge-danger" v-else>
                                        <i class="mdi mdi-close"></i>
                                    </span>
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="series.show_in_coach">
                                        <i class="mdi mdi-check"></i>
                                    </span>
                                    <span class="badge badge-danger" v-else>
                                        <i class="mdi mdi-close"></i>
                                    </span>
                                </td>
                                <td>{{ series.video_count }}</td>
                                <td>
                                    <router-link tag="button" class="btn btn-outline-primary btn-sm" :to="{name: 'series.show', params: {slug: series.slug}}">
                                        <i class="mdi mdi-eye"></i>
                                    </router-link>
                                    <router-link tag="button" class="btn btn-outline-warning btn-sm" :to="{name: 'admin.series.edit', params: {slug: series.slug}}">
                                        <i class="mdi mdi-pencil"></i>
                                    </router-link>
                                    <router-link tag="button" class="btn btn-outline-dark btn-sm" :to="{name: 'admin.series.videos', params: {slug: series.slug}}">
                                        <i class="mdi mdi-television"></i>
                                    </router-link>

                                    <button class="btn btn-outline-danger btn-sm float-right" @click="selectedSeries = series">
                                        <i class="mdi mdi-trash-can"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <series-delete-modal :selected="selectedSeries" @series-deleted="onSeriesDeleted" @modal-close="selectedSeries = null"></series-delete-modal>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminSeriesRepository from "../../../repositories/Admin/AdminSeriesRepository";
import SeriesDeleteModal from "./SeriesDeleteModal";
export default {
name: "SeriesManagement",
    components: {SeriesDeleteModal, PageHeader},
    data: () => ({
        seriesList: [],
        selectedSeries: null,
    }),
    mounted() {
        this.getAllSeries();
    },
    methods: {
        getAllSeries() {
            AdminSeriesRepository
                .getAllSeries()
                .then((res) => this.seriesList = res.data);
        },
        onSeriesDeleted() {
            this.$snotify.success(this.$t('actions.deleted'));
            this.selectedSeries = null;
            this.getAllSeries();
        }
    }
}
</script>

<style scoped>

</style>
